import React from "react";
import classes from "./CardsArea.module.scss";

export default function CardsArea({ children, classesName = "", journeyCodeFour = false }: any) {
  classesName += " " + classes.CardsArea;
  if (journeyCodeFour) classesName += " " + classes.centerizeArea
  return <div className={classesName}>{children}</div>;
}
